import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import SocialLoginState from '../types/SocialLoginState'

export const socialLogin: Module<SocialLoginState, RootState> = {
  namespaced: true,
  state: {},
  getters,
  actions,
  mutations
}
